import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  tid: number;
  name: string;
  field_mandarin_title: string;
  field_malay_title: string;
  field_category_id: string;
  field_sub_order_seq: string;
  field_sub_categories_status: boolean;
  field_sub_published: boolean;
  field_sub_created_at: boolean;
  field_sub_updated_at: boolean;
}

// edit api call
const fetchSubCategoriesDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/get-all-sub-categories/${id}`);
  return response.data[0];
};

const useSubCategoriesDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["subCategoriesDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchSubCategoriesDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useSubCategoriesDocumentDetails };
